import BaseHttpClient from "@/core/HttpResources/BaseHttpClient";

export default class ProjectTypeService {
  private client: BaseHttpClient;
  constructor(public controller: string = "ProjectTypes") {
    this.client = new BaseHttpClient(controller);
  }

  public async getAll() {
    try {
      var result = await this.client.getAsync<any>();
      return result;
    } catch (error) {
      throw error;
    }
  }
}
